exports = module.exports = require("../../node_modules/_css-loader@0.28.7@css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".icons[data-v-4d16a0fc]{font-size:24px;color:#3cc51f}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.7@css-loader?minimize!./node_modules/_vue-loader@13.5.0@vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4d16a0fc","scoped":true,"hasInlineConfig":false}!./node_modules/_vue-loader@13.5.0@vue-loader/lib/selector.js?type=styles&index=0!./src/demos/Icons.vue
// module id = N9YY
// module chunks = 1